import * as React from 'react';

import {Button} from 'shells/button/button';

import type {LandingPageFullFragment} from 'nutshell-graphql-types';

import {EmbedPageModal} from './embed-page-modal';

type Props = {
    page: LandingPageFullFragment;
};

export const EmbedPageButton = (props: Props) => {
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    if (!props.page.iframeEmbedCode) {
        return null;
    }

    return (
        <>
            {isModalOpen && <EmbedPageModal embedCode={props.page.iframeEmbedCode} />}
            <Button
                onClick={() => {
                    setIsModalOpen(true);
                }}
                size='big'
                variant='secondary'
            >
                Embed this page
            </Button>
        </>
    );
};
